import React, { Component } from 'react';
import { Menu, Icon, Container } from 'semantic-ui-react';

class MainMenu extends Component {
  render() {
    return (
			<Menu fixed='top' inverted>
				<Container>
					<Menu.Item
            as='a'
            href='/'
            header
          >
            <Icon name='snowflake outline' />
						Rymac, Inc.
					</Menu.Item>
					<Menu.Item as='a' href='#about'>
            About
          </Menu.Item>
					<Menu.Item as='a' href='#services'>
            Services
          </Menu.Item>
					<Menu.Item as='a' href='#customers'>
            Customers
          </Menu.Item>
					<Menu.Item as='a' href='#contact'>
            Contact
          </Menu.Item>
				</Container>
			</Menu>
    );
  }
}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu.jsx